import NoShipments from '../organs/noShipments';
import ShipmentCard from '../organs/shipmentCard';
import {useShipmentsStore} from '../../store/shipmentsStore';
import React, {useEffect} from 'react';
import OrderStatusTrackingLoader from './orderStatusTrackingLoader';
import {
    Card,
    Icon,
    Icons,
    IconSizes,
    Typography,
} from '@toppy-webshop/toppy-design-system';
import {useAuthStore} from '../../store/authStore';
import DelayInfo from '../organs/DelayInfo';
import {Order} from '../../models/order';

const ShipmentsSection = ({order}: {order: Order}) => {
    const {bearer} = useAuthStore(state => state);
    const {shipments, fetchShipments, delayMessage} = useShipmentsStore(
        state => state
    );

    useEffect(() => {
        if (bearer === null) {
            return;
        }

        fetchShipments(bearer);
    }, [bearer, fetchShipments]);

    const totalShipmentCount =
        shipments === null
            ? 0
            : shipments.filter(shipment => !shipment.hasBackorder).length;

    return (
        <section id={'status-container'}>
            <Typography variant={'h5'}>
                <Icon
                    icon={Icons.TOPPY_BOX_SPEED}
                    size={IconSizes.L}
                    color={'yellow'}
                />
                &nbsp; Mijn zendingen
            </Typography>
            {null === shipments && (
                <Card>
                    <OrderStatusTrackingLoader
                        style={{width: '100%', height: '100%'}}
                    />
                </Card>
            )}
            {null !== shipments && shipments.length <= 0 && (
                <NoShipments order={order} />
            )}
            {null !== shipments &&
                shipments.length > 0 &&
                shipments.map((shipment, index) => (
                    <div key={index}>
                        {shipments.filter(shipment => shipment.isDelayed)
                            .length > 0 && (
                            <DelayInfo infoText={delayMessage} />
                        )}
                        <ShipmentCard
                            shipmentIndex={index}
                            totalShipmentCount={totalShipmentCount}
                            key={shipment.id}
                            shipment={shipment}
                        />
                    </div>
                ))}
        </section>
    );
};

export default ShipmentsSection;
